import { Text, VStack } from "@chakra-ui/react"
import { UserContext, UserContextProps } from "./providers/UserProvider"
import { useContext, useEffect } from 'react'
import { useNavigate } from "react-router-dom"

const LoadingPage = () => {
    const { user } = useContext(UserContext) as UserContextProps
    const navigate = useNavigate()
    useEffect(()=> {
        if(user){
            navigate('/get-in')
        }
    }, [user, navigate])

    return (
        <VStack w={'full'} h={'100vh'} justify={'center'}>
            <Text fontSize={'3xl'}>Loading, please wait . . .</Text>
        </VStack>
    )
}

export default LoadingPage